import { makeAutoObservable } from 'mobx'

export enum POPUP_TYPE {
  CONFIRM_POPUP = 'CONFIRM_POPUP',
  ACCEPT_POPUP = 'ACCEPT_POPUP',
}

type CONFIRM_POPUP_DATA = {
  title: string
  description?: string
  button?: string
}

type ACCEPT_POPUP_DATA = {
  title: string
  description?: string
  cancelButton?: string
  acceptButton?: string
}

export type POPUP_DATA = {
  [key: string]: any
}
export class PopupStore {
  activated: POPUP_TYPE = null

  activatedMessage: boolean = false
  messageData: POPUP_DATA | null = null

  data: POPUP_DATA | null = null

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  hideTimerId = setTimeout(() => {})

  /**
   * @param {string} name - popup type
   * @param {object} data - data for the popup
   * @param {number} time - time in milliseconds
   */
  showPopup(name: POPUP_TYPE, data: POPUP_DATA | null = null, time?: number) {
    this.activated = name
    this.data = data

    if (time) {
      this.hideTimerId = setTimeout(this.hidePopup.bind(this), time)
    }
  }

  hidePopup(status = true) {
    clearTimeout(this.hideTimerId)
    const onClose = this.data?.onClose ? this.data.onClose : () => {}
    this.activated = null
    this.data = null
    onClose(status)
  }
}

export const popupStore = new PopupStore()
